import React from 'react';
import Header from './Header';
import Hero from './Hero';
import ProblemSection from './ProblemSection';
import ValueProposition from './ValueProposition';
import Features from './Features';
import WhyThisWorks from './WhyThisWorks';
import WhoIsThisFor from './WhoIsThisFor';
import RealExample from './RealExample';
import FinancialProjections from './FinancialProjections';
import InvestmentRequired from './InvestmentRequired';
import Testimonials from './Testimonials';
import CredibilitySection from './CredibilitySection';
import FAQ from './FAQ';
import Pricing from './Pricing';
import FinalCTA from './FinalCTA';
import TrustBadges from './TrustBadges';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <ProblemSection />
      <ValueProposition />
      <Features />
      <WhyThisWorks />
      <WhoIsThisFor />
      <RealExample />
      <FinancialProjections />
      <InvestmentRequired />
      <Testimonials />
      <CredibilitySection />
      <FAQ />
      <Pricing />
      <FinalCTA />
      <TrustBadges />
      <Footer />
    </div>
  );
};

export default LandingPage;
